import { render, staticRenderFns } from "./AuthAndAutorizedPage.vue?vue&type=template&id=43f9f3c8&"
import script from "./AuthAndAutorizedPage.vue?vue&type=script&lang=js&"
export * from "./AuthAndAutorizedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports